import type { TabMetadata } from '@mdev/common';

export const tabMetadata: TabMetadata[] = [
  {
    id: 'methylation',
    name: 'Methylation',
    shortName: 'Methylation',
    description: 'Core methylation pathway variants from v1 analysis',
    color: 'violet',
  },
  {
    id: 'detox',
    name: 'Detox (Phase I/II/III)',
    shortName: 'Detox',
    description:
      'Comprehensive detoxification pathways including CYP enzymes, GSTs, and transporters',
    color: 'purple',
  },
  {
    id: 'vitamin-d',
    name: 'Vitamin D Pathway',
    shortName: 'Vitamin D',
    description: 'Vitamin D synthesis, transport, metabolism, and receptor function',
    color: 'yellow',
  },
  {
    id: 'one-carbon',
    name: 'B12/Folate/One-Carbon & Choline',
    shortName: 'B12/Folate',
    description: 'B12 absorption, folate transport, one-carbon metabolism, and choline pathways',
    color: 'blue',
  },
  {
    id: 'vitamin-c',
    name: 'Vitamin C Transport',
    shortName: 'Vitamin C',
    description: 'Vitamin C cellular transport and bioavailability',
    color: 'orange',
  },
  {
    id: 'mineral-metabolism',
    name: 'Mineral Metabolism (Iron/Ca/Zn)',
    shortName: 'Minerals',
    description: 'Iron homeostasis, calcium sensing, and zinc transport',
    color: 'red',
  },
  {
    id: 'pufas',
    name: 'PUFAs & Lipids',
    shortName: 'Fatty Acids',
    description: 'Polyunsaturated fatty acid metabolism, desaturation, and lipid processing',
    color: 'green',
  },
  {
    id: 'gi-tolerance',
    name: 'GI Tolerance & Immune Tags',
    shortName: 'GI & Immune',
    description: 'Lactose tolerance and celiac disease risk markers',
    color: 'pink',
  },
  {
    id: 'oxidative',
    name: 'Oxidative Stress & Antioxidants',
    shortName: 'Antioxidants',
    description: 'Antioxidant enzyme systems and oxidative stress response pathways',
    color: 'teal',
  },
  {
    id: 'metabolic',
    name: 'Energy & Mitochondrial / Metabolic Context',
    shortName: 'Metabolic',
    description: 'Energy metabolism, mitochondrial function, and metabolic trait variants',
    color: 'indigo',
  },
  {
    id: 'alcohol-caffeine',
    name: 'Alcohol & Caffeine Metabolism',
    shortName: 'Alcohol/Caffeine',
    description:
      'Alcohol dehydrogenase, aldehyde metabolism, and caffeine processing variants',
    color: 'grape',
  },
];

export const getTabMetadata = (tabId: string): TabMetadata | undefined =>
  tabMetadata.find((tab) => tab.id === tabId);

export const getAllTabIds = (): string[] => tabMetadata.map((tab) => tab.id);
